import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../../fleet-management/backend-service/backend-service';
import { SharedService } from '../../share-data/shared.service';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../fleet-management/transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { GlobalVariablesService } from '../../global.service';

@Component({
  selector: 'app-booking-list',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './booking-list.component.html',
  styleUrl: './booking-list.component.scss'
})
export class BookingListComponent implements OnDestroy {

  selectedBookingId: string | null = null;
  selectedStatusDropdown: string | null = null;
  expandedLocationId: string | null = null;
  selectedFilterStatus: number | null = null;
  filterStatusOpen: boolean = false;
  filterSelectionOpen: boolean = false;
  dropdownPosition: { top: number; left: number } = { top: 0, left: 0 };
  statusDropdownOpenUpward: boolean = false;
  searchText: string = '';
  datas: any[] = [];

  selectionTypes = [
    { value: 'reference',        label: 'Reference' },
    { value: 'customerName',     label: 'Customer Name' },
    { value: 'deliveryLocation', label: 'Delivery Location' },
    { value: 'plateNumber',      label: 'Plate Number' },
    { value: 'driverName',       label: 'Driver Name' },
    { value: 'driverNumber',     label: 'Driver Number' },
  ];
  selectedSelectionType: { value: string; label: string } | null = null;
  latitude = 10.7769;
  longitude = 106.7009;
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  get statusOptions(): { id: number; name: string }[] {
    return this.globalVariable.ORDER_BOOKING_STATUS || [];
  }

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private notification: NotificationService, public loadingService: LoadingService, private globalVariable: GlobalVariablesService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }


  ngOnInit() {
    this.getConsigneeList();
  }
  get pagedOrders() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredOrders.slice(start, start + this.pageSize);
  }
  addNewBooking() {
    this.router.navigate(['/home/shipping-order/booking-list/order-booking']);
  }

  get filteredOrders() {
    let result = this.datas;

    if (this.selectedFilterStatus !== null) {
      result = result.filter(data => data.orderBookingStatus === this.selectedFilterStatus);
    }

    if (this.searchText.trim()) {
      const searchLower = this.searchText.toLowerCase();
      result = result.filter(data =>
        (data.reference?.toLowerCase() || '').includes(searchLower) ||
        (data.customer?.name?.toLowerCase() || '').includes(searchLower) ||
        (data.deliveryLocation?.address?.toLowerCase() || '').includes(searchLower) ||
        (data.pickupLocation?.address?.toLowerCase() || '').includes(searchLower) ||
        (data.assignedTrucks || []).some((truck: any) =>
          (truck.plateNumber?.toLowerCase() || '').includes(searchLower) ||
          (truck.driverName?.toLowerCase() || '').includes(searchLower) ||
          (truck.driverPhone?.toLowerCase() || '').includes(searchLower)
        )
      );
    }

    return result;
  }

  clearSearch() {
    this.searchText = '';
    if (this.selectedSelectionType) {
      this.getConsigneeList(1);
    }
  }

  toggleFilterSelection(event: MouseEvent) {
    event.stopPropagation();
    this.filterSelectionOpen = !this.filterSelectionOpen;
    this.filterStatusOpen = false;
  }

  selectSelectionType(type: { value: string; label: string } | null) {
    this.selectedSelectionType = type;
    this.filterSelectionOpen = false;
    this.searchText = '';
    this.getConsigneeList(1);
  }

  get selectedSelectionLabel(): string {
    return this.selectedSelectionType ? this.selectedSelectionType.label : 'Search By';
  }

  onSearchInput() {
    if (this.selectedSelectionType && this.searchText.trim().length > 0) {
      this.getConsigneeList(1);
    } else if (!this.selectedSelectionType) {
      // local filter handled by filteredOrders getter
    }
  }

  toggleFilterStatus(event: MouseEvent) {
    event.stopPropagation();
    this.filterStatusOpen = !this.filterStatusOpen;
    this.filterSelectionOpen = false;
  }

  selectFilterStatus(status: { id: number; name: string } | null) {
    this.selectedFilterStatus = status ? status.id : null;
    this.filterStatusOpen = false;
    this.getConsigneeList(1);
  }

  get selectedFilterStatusName(): string {
    if (this.selectedFilterStatus === null) return 'All Status';
    return this.statusOptions.find(s => s.id === this.selectedFilterStatus)?.name || 'All Status';
  }

  getConsigneeList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    const statusParam = this.selectedFilterStatus !== null ? `&status=${this.selectedFilterStatus}` : '';

    let endpoint: string;
    if (this.selectedSelectionType && this.searchText.trim().length > 0) {
      endpoint = `/api/orders/search?selectionType=${this.selectedSelectionType.value}&search=${encodeURIComponent(this.searchText.trim())}&page=${page}&limit=${this.pageSize}${statusParam}`;
    } else {
      endpoint = `/api/orders?page=${page}&limit=${this.pageSize}${statusParam}`;
    }

    this.apiService.get(endpoint, loginData.token).subscribe({
      next: (response) => {
        console.log('/api/orders/list' + ',\n' + 'Consignee_List_Response:', response.body);
        if (response.status === 200) {
          this.datas = response.body.orders;
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        this.notification.error('Failed to load bookings. Please try again.');
      }
    });
  }
  editConsignee(data: any) {
    console.log("Selected Id: ", data.id)
    if (this.selectedBookingId === data.id) {
      this.selectedBookingId = null;
    } else {
      this.selectedBookingId = data.id;
    }
  }
  onViewBooking(data: any) {
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/shipping-order/booking-list/order-booking/:id'],
      { queryParams: { isEdit: true, isReadOnly: true } }
    );
  }

  onEdit(data: any) {
    this.selectedBookingId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/shipping-order/booking-list/order-booking/:id'],
      { queryParams: { isEdit: true, isReadOnly: false } }
    );
  }

  onDelete(data: any) {
    this.selectedBookingId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.reference, title: 'Delete Booking', confirmLabel: 'Delete', message: 'Are you sure you want to delete booking' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteConsignee(data);
      }
    });
  }
  deleteConsignee(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/orders/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/orders/delete' + ',\n' + 'Order_Delete_Response:', response);
        if (response.status === 200) {
          this.datas = response.body;
        }
        else {
          console.log("Hey you")
        }
        this.notification.success(response.message || 'Operation completed successfully');
        this.getConsigneeList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        this.notification.error('Failed to delete booking. Please try again.');
      }
    });
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedBookingId = null;
    }

    // Close status dropdown if clicked outside
    if (!target.closest('.status-badge') && !target.closest('.status-dropdown-menu')) {
      this.selectedStatusDropdown = null;
    }

    // Close location popover if clicked outside
    if (!target.closest('.location-expand-btn') && !target.closest('.location-popover')) {
      this.expandedLocationId = null;
    }

    // Close filter status dropdown if clicked outside
    if (!target.closest('.filter-status-btn') && !target.closest('.filter-status-menu')) {
      this.filterStatusOpen = false;
    }

    // Close selection type dropdown if clicked outside
    if (!target.closest('.filter-selection-btn') && !target.closest('.filter-selection-menu')) {
      this.filterSelectionOpen = false;
    }
  }

  toggleStatusDropdown(bookingId: string, event: MouseEvent) {
    event.stopPropagation();
    if (this.selectedStatusDropdown === bookingId) {
      this.selectedStatusDropdown = null;
    } else {
      const badge = event.currentTarget as HTMLElement;
      const rect = badge.getBoundingClientRect();
      const estimatedDropdownHeight = this.statusOptions.length * 40 + 12;
      this.statusDropdownOpenUpward = (window.innerHeight - rect.bottom) < estimatedDropdownHeight;
      this.selectedStatusDropdown = bookingId;
    }
  }

  updateStatus(booking: any, newStatus: any, event: MouseEvent) {
    event.stopPropagation();
    this.selectedStatusDropdown = null;

    // Show confirmation dialog
    const confirmed = window.confirm(`Are you sure to update the status to "${newStatus.name}"?`);

    if (!confirmed) {
      return;
    }

    let loginData = JSON.parse(localStorage.getItem('loginData')!);
    const payload = { orderBookingStatus: newStatus.id };
    console.log('Payload for status update:', payload);
    console.log('Updating status for booking ID:', booking.id, 'to new status:', newStatus.name);

    this.apiService.put(`/api/orders/${booking.id}/status`, payload, loginData.token).subscribe({
      next: (response: any) => {
        console.log('Status Update Response:', response);
        if (response.status === 200) {
          booking.orderBookingStatus = newStatus.id;
          this.notification.success(`Status updated to ${newStatus.name}`);
        } else {
          this.notification.error('Failed to update status. Please try again.');
        }
      },
      error: (error: any) => {
        console.error('Error updating status:', error);
        this.notification.error('Failed to update status. Please try again.');
      }
    });
  }

  getStatusName(statusId: number): string {
    const options = this.statusOptions;
    const found = options.find((s: any) => s.id === statusId);
    return found ? found.name : 'Unknown';
  }

  truncateLocation(address: string | undefined): string {
    if (!address) return 'N/A';
    return address.length > 40 ? address.substring(0, 40) + '...' : address;
  }

  isLocationTruncated(address: string | undefined): boolean {
    return !!address && address.length > 40;
  }

  toggleLocationExpand(id: string, event: MouseEvent) {
    event.stopPropagation();
    this.expandedLocationId = this.expandedLocationId === id ? null : id;
  }

  getStatusClass(status: string): string {
    const statusLower = status?.toLowerCase().replace(/\s+/g, '-') || '';
    return `status-${statusLower}`;
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

}
